export type { TrailNumberProps } from "./trail-number";
export { TrailNumber } from "./trail-number";
